import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item,
        class: _normalizeClass(["list-group-item", { active2: _ctx.currentPost.id === item.id }]),
        onClick: ($event: any) => (_ctx.setCurrentItem(item.id))
      }, [
        _createElementVNode("strong", null, _toDisplayString(item.title), 1),
        _hoisted_3,
        _createElementVNode("span", {
          innerHTML: _ctx.setShortDescription(item.body, 60)
        }, null, 8, _hoisted_4)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}